'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreloaderGlobal = exports.Preloader = undefined;

var _Preloader2 = require('./Preloader');

var _Preloader3 = _interopRequireDefault(_Preloader2);

var _PreloaderGlobal2 = require('./PreloaderGlobal');

var _PreloaderGlobal3 = _interopRequireDefault(_PreloaderGlobal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Preloader = _Preloader3.default;
exports.PreloaderGlobal = _PreloaderGlobal3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Preloader/index.js
// module id = 1737
// module chunks = 0